<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="cliente">

                <ol class="breadcrumb">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li>
                        <a href="#/clientes">
                            <i class="fa fa-id-card-o" aria-hidden="true"></i> CLIENTES
                        </a>
                    </li>
                    <li class="active">
                        CADASTRO DE CLIENTES
                    </li>
                </ol>

                <div class="col-md-3">
                    <menu-cliente :cliente="cliente" ></menu-cliente>
                </div>
                <div class="col-md-9" >

                    <form class="form-horizontal">

                        <div class="panel panel-info" v-if="user">
                            <!-- Default panel contents -->
                            <div class="panel-heading">
                                <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                            </div>
                            <div class="panel-body">

                                <div class="form-group">

                                    <div class="col-sm-12">
                                        <label class="control-label">NOME DO CLIENTE</label>
                                        <input :disabled="user.level >= 5" type="text" v-model="cliente.nome"
                                               class="form-control" title="nome">
                                    </div>

                                    <div class="col-sm-12">
                                        <label class="control-label">EMAIL DO CLIENTE</label>
                                        <input :disabled="user.level >= 5" type="text" v-model="cliente.email"
                                               class="form-control" title="email">
                                    </div>

                                    <div class="col-sm-3">
                                        <label class="control-label">TIPO DO CLIENTE</label>
                                        <tipo_pessoa @input="update($event)" :readonly="user.level >= 5"
                                                     v-model="cliente.tipo_cliente"></tipo_pessoa>
                                    </div>

                                    <div class="col-sm-3" v-if="tipo === 'f'">
                                        <label class="control-label">CPF</label>
                                        <!--
                                        <input id="cpf" v-mask="'999.999.999-99'" :disabled="user.level >= 5"
                                               maxlength="14" type="text" v-model="cliente.cpf"
                                               class="form-control" title="cpf">-->
                                        <masked-input v-model="cliente.cpf" class="form-control"
                                                      mask="111.111.111-11" placeholder="###.###.###-##" ></masked-input>
                                    </div>

                                    <div class="col-sm-3" v-if="tipo === 'j'">
                                        <label class="control-label">CNPJ</label>
                                        <!--<input id="cnpj" v-mask="'99-999.999/9999-99'" :disabled="user.level >= 5"
                                               maxlength="18" type="text" v-model="cliente.cnpj"
                                               class="form-control" title="cnpj">-->
                                        <masked-input v-model="cliente.cnpj" class="form-control"
                                                      mask="11-111.111/1111-11" placeholder="##-###.###/####-##" ></masked-input>
                                    </div>

                                    <div class="col-sm-12" v-if="tipo === 'j'">
                                        <label class="control-label" >RAZAO SOCIAL</label>
                                        <input :disabled="user.level >= 5" type="text" v-model="cliente.razao_social"
                                               class="form-control"  title="razao social">
                                    </div>

                                </div>
                            </div>
                        </div>

                        <street :disabled="user.level >= 5" :street="cliente.street"></street>

                        <telefones :readonly="user.level >= 5" :telefones="cliente.telefones"></telefones>

                        <div class="form-group">
                            <div class="col-sm-10">
                                <button type="button" v-if="user.level < 5"
                                        @click="save()"
                                        class="btn btn-success">
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR CLIENTE
                                </button>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuCliente from "../../../menus/clientes.vue";
import { Cliente } from "../../../class/index";
import { Ssh, Street, Telefones } from "../../../components/exports";
import tipo_pessoa from "../../../components/combo/tipo_pessoa.vue";
import MaskedInput from "vue-masked-input";

export default {
    components: {
        MenuCliente,
        Street,
        Telefones,
        tipo_pessoa,
        MaskedInput
    },
    data() {
        return {
            cliente: null,
            user: null,
            tipo: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadCliente(this.$route.params.id);
        } else {
            this.cliente = Cliente.create();
        }
    },
    methods: {
        update(ev) {
            this.cliente.tipo_cliente = ev;
            this.tipo = ev;
            this.$nextTick(function() {
                console.log("update()", this.cliente);
            });
        },
        loadCliente(id) {
            Cliente.byID(id)
                .then(row => {
                    this.tipo = row.tipo_cliente;
                    this.cliente = row;
                })
                .catch(err => console.error(err));
        },
        save() {
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o cliente?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Cliente.save(this.cliente)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/clientes" });
                                })
                                .catch(err => {
                                    if (err.status === 402) {
                                        swal(
                                            "Problemas!",
                                            err.body.error,
                                            "error"
                                        );
                                    }
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
